export enum LifestyleDetectionsPermissions {
  READ_LIFESTYLE_DETECTIONS_INDEX_ES_QUERY = 'read_lifestyle_detections_index_es_query'
}
